import React, { Component, Fragment } from 'react'
import moment from 'moment'
import {
  DatePicker,
  Layout,
  Breadcrumb,
  Form,
  Input,
  Divider,
  Row,
  Col,
  Avatar,
  Select,
  Switch,
  Tag,
  Icon,
  Button,
  Checkbox,
  message,
  notification,
  Skeleton,
  Popover,
  Radio,
  Spin,
  Tabs,
  InputNumber,
  List,
  Card,
} from 'antd'
import _ from 'lodash'
import $ from 'jquery'
import {
  SearchOutlined,
  CopyOutlined,
  FormOutlined,
  ShopOutlined,
} from '@ant-design/icons'
// import styles from './styles.module.scss';
import AppHelper from 'libs/AppHelper'
import { API_HOST } from '../../configs/env'
import whttp from '../../libs/whttp'
import Errors from 'validatorjs/src/errors'
import ValidatorErrorAlert from '../../components/ValidatorErrorAlert/ValidatorErrorAlert'
import CitySelect from 'components/CitySelect/CitySelect'
import { genFormItemAtrribute } from 'libs/FormHelper'
import { RadioControl, CheckboxControl } from '@wordpress/components'
import { withState } from '@wordpress/compose'
import bannerImage from 'assets/img/banner/banner-catalog.png'
import { store } from '../../reducers'
import { updateAuthInfo } from '../../reducers/auth'
import { UploadOutlined } from '@ant-design/icons'
import WUpload from 'components/WUpload/WUpload'
import { __ } from '@wordpress/i18n'

const VC_CONFIG = _.get(window, 'VC_CONFIG', {})
const Local = _.get(window, 'VC_CONFIG.Locale')
const defaultListInfo = {
  current: 1, //目前頁數
  page_size: 10, //一頁幾筆
  total: 1, //以此query條件，總共幾筆資料
  rows: [],
}
const Option = Select.Option
const { TabPane } = Tabs
// 前端頁面
export default class UserPayment extends Component {
  formRef = React.createRef()
  state = {
    query: {},
    listInfo: _.cloneDeep(defaultListInfo),
    tableData: [],
    selectmonth: moment()
      .startOf('month')
      .format('YYYY-MM-DD'),
    isLoading: true,
  }

  componentDidMount() {
    var date = new Date(),
      y = date.getFullYear(),
      m = date.getMonth()
    var firstDay = new Date(y, m, 1)
    var lastDay = new Date(y, m + 1, 0)
    const query = {
      start_dt: moment(firstDay).format('YYYY-MM-DD'),
      end_dt: moment(lastDay).format('YYYY-MM-DD'),
    }
    // AppHelper.updateConfig()
    this.setState({ query })
    this.setState({ info: this.props.user }, () => {
      this.reloadTab()
    })
    this.loadData(query)

    // AppHelper.updateUserInfo(() => {

    //   this.setState({ isFetchData: false })

    //   this.fillData(this.props.user)
    // });

    // 登入換 tokne
    //http://cec.syscom.tw:8880/api/account/getAccessToken?code=4854c9565059992e98a33fbcde41597f
    // 電子發票列表
    // http://{{hostip}}//api/account/eInvoiceList
    // 點數紀錄 / 消費記錄
    // 密碼變更
    // 查詢編輯會員資料
    // 查詢好康卡會員資料
  }
  reloadTab = () => {
    // tab 共用動態
    var $el, leftPos, newWidth
    /* Add Magic Line markup via JavaScript, because it ain't gonna work without */
    let $magicLine = $('#magic-line')

    if (!_.get($magicLine, 0)) {
      console.log('kkk c', $magicLine)
      $('.basic-tabs-label ul').append("<li id='magic-line'></li>")
    }
    /* Cache it */
    $magicLine = $('#magic-line')

    $magicLine
      .width($('.current_page_item').width())
      .css('left', $('.current_page_item a').position().left)
      .data('origLeft', $magicLine.position().left)
      .data('origWidth', $magicLine.width())

    $('.basic-tabs-label ul li a').unbind('mouseenter mouseleave')
    $('.basic-tabs-label ul li')
      .find('a')
      .hover(
        function() {
          $el = $(this)
          console.log('basic-tabs-label', $el)
          leftPos = $el.position().left
          newWidth = $el.parent().width()

          $magicLine.stop().animate({
            left: leftPos,
            width: newWidth,
          })
        },
        function() {
          $magicLine.stop().animate({
            left: $magicLine.data('origLeft'),
            width: $magicLine.data('origWidth'),
          })
        }
      )

    $('#pills-tab .nav-item').unbind('mouseenter mouseleave')
    $('#pills-tab .nav-item')
      .mouseenter(function() {
        if (!$(this).hasClass('highlight')) {
          $('.highlight').removeClass('current_page_item')
        }
      })
      .mouseleave(function() {
        $('.highlight').addClass('current_page_item')
      })
  }
  loadData = (query = {}) => {
    console.log('loadData', query)
    //const { query } = this.state;
    const { page, page_size } = { page: 1, page_size: 'all' }

    this.setState({ isLoadingData: true })

    whttp.post(
      API_HOST + '/api/account/pointsDetail',
      {
        start_dt: query.start_dt,
        end_dt: query.end_dt,
      },
      (state, res) => {
        this.setState({ isLoadingData: false })
        const { code = 100, reason = '發生錯誤', data = {} } = res

        if (state === false) {
          return this.setState({ message: '發生錯誤' })
        }

        if (code !== 200) {
          return this.setState({ message: reason })
        }
        console.log(code, reason, data, res)
        this.setState({ tableData: data.pointsdetail }, () => {
          this.refreshPicker()
        })
      }
    )
  }
  fillData = (data = {}) => {
    if (!this.formRef.current) return

    // 處理資料，本地適合Form Control的資料
    if (!_.isNil(data.address) || !_.isObject(data.address)) {
      data.address = {
        city_id: _.get(data, 'city_id'),
        area_id: _.get(data, 'area_id'),
      }
    }

    console.log('filldata', data)
    this.formRef.current.setFieldsValue(data)
    this.setState({ isLoading: false }, () => {
      this.reloadTab()
    })
  }

  submitData = (info = {}) => {
    this.setState({ isSubmitData: true, messages: {} })

    whttp.post(API_HOST + `/api/account/changePwd`, info, (state, res) => {
      console.log(state, res)
      this.setState({ isSubmitData: false })

      const { code = 100, reason = '發生錯誤', data = {} } = res

      if (state === false) {
        return message.error('發生錯誤')
      }

      if (code !== 200) {
        notification['error']({
          message: '更新失敗',
          description: reason,
        })

        return this.setState({ messages: data.messages || {} })
      }

      message.success('修改成功')
    })
  }

  refreshPicker = _.debounce(() => {
    $('.selectpicker').selectpicker('refresh')
  }, 1000)

  TransType = (item) => {
    if (item == 'BLC') return '點數結餘'
    else if (item == 'ADJ') return '點數調整'
    else if (item == 'RDM') return '紅利折抵'
    else if (item == 'PUR') return '消費'
    else return '消費'
  }

  render() {
    const errors = _.get(this, 'state.validator.errors', new Errors())
    const options = _.get(this, 'props.app.options', {})
    const { query, info, tableData = [] } = this.state
    var date = new Date(),
      y = date.getFullYear(),
      m = date.getMonth()
    var firstDay = new Date(y, m, 1)
    var lastDay = new Date(y, m + 1, 0)
    var tmpStr_area = '',
      tmpResult_area =
        '<option value="' +
        moment(firstDay).format('YYYY-MM-DD') +
        '">' +
        moment(firstDay).format('YYYY年MM月') +
        '</option>'
    for (var i = 0; i < 5; i++) {
      tmpStr_area =
        '<option value="' +
        moment(firstDay)
          .subtract(1, 'months')
          .format('YYYY-MM-DD') +
        '">' +
        moment(firstDay)
          .subtract(1, 'months')
          .format('YYYY年MM月') +
        '</option>'
      tmpResult_area = tmpResult_area + tmpStr_area
      firstDay = moment(firstDay)
        .subtract(1, 'months')
        .format('YYYY-MM-DD')
      lastDay = moment(lastDay)
        .subtract(1, 'months')
        .format('YYYY-MM-DD')
    }
    console.log('option', tmpResult_area)
    $('#SelectMonth').html(tmpResult_area)
    this.refreshPicker()
    console.log('tableData', tableData)
    return (
      <div>
        <main className='bg-light'>
          <div className='container'>
            <section className='pt-2 pb-2'>
              <div className='breadcrumb-wrap'>
                <nav aria-label='breadcrumb'>
                  {Local == 'zh_TW' && (
                    <ol className='breadcrumb'>
                      <li className='breadcrumb-item'>
                        <a href={`${VC_CONFIG.INDEX_URL}/`}>
                          {__('首頁', 'cec-plugin-stores')}
                        </a>
                      </li>
                      <li className='breadcrumb-item'>
                        <a href={`${VC_CONFIG.INDEX_URL}/profile`}>
                          {__('會員中心', 'cec-plugin-stores')}
                        </a>
                      </li>
                      <li
                        className='breadcrumb-item active'
                        aria-current='page'>
                        {__('點數紀錄', 'cec-plugin-stores')}
                      </li>
                    </ol>
                  )}
                  {Local == 'en_US' && (
                    <ol className='breadcrumb'>
                      <li className='breadcrumb-item'>
                        <a href={`${VC_CONFIG.INDEX_URL}/en`}>
                          {__('首頁', 'cec-plugin-stores')}
                        </a>
                      </li>
                      <li className='breadcrumb-item'>
                        <a href={`${VC_CONFIG.INDEX_URL}/profile-en`}>
                          {__('會員中心', 'cec-plugin-stores')}
                        </a>
                      </li>
                      <li
                        className='breadcrumb-item active'
                        aria-current='page'>
                        {__('點數紀錄', 'cec-plugin-stores')}
                      </li>
                    </ol>
                  )}
                </nav>
              </div>
              <h6 className='h5 lh-h4 mb-5 text-navy text-lg-left text-center'>
                {__('親愛的', 'cec-plugin-stores')}{' '}
                <b className='fw-700'>{info && info.cn_name}</b>
                <br className='d-block d-lg-none' />
                {__('您好，歡迎來到會員中心！', 'cec-plugin-stores')}
              </h6>
            </section>
          </div>
          <section className='pt-0'>
            <div className='mb-5 basic-tabs-label'>
              {Local == 'zh_TW' && (
                <ul className='nav nav-pills' id='pills-tab'>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/profile`}>
                      {__('網站帳號', 'cec-plugin-stores')}
                    </a>
                  </li>
                  {info && info.spcode === 'C4' && (
                    <li className='nav-item'>
                      <a
                        className='nav-link'
                        href={`${VC_CONFIG.INDEX_URL}/pwd`}>
                        {__('更改密碼', 'cec-plugin-stores')}
                      </a>
                    </li>
                  )}
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/loyaltyprofile`}>
                      {__('好康卡會員資料', 'cec-plugin-stores')}
                    </a>
                  </li>
                  {/* <li className="nav-item"><a className="nav-link" href={`${VC_CONFIG.INDEX_URL}/payment`} >{__('我的消費紀錄','cec-plugin-stores')}</a></li> */}
                  <li className='nav-item current_page_item highlight'>
                    <a className='nav-link'>
                      {__('點數紀錄', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/invoice`}>
                      {__('電子發票記錄', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/connect`}>
                      {__('第三方登入設定', 'cec-plugin-stores')}
                    </a>
                  </li>
                </ul>
              )}
              {Local == 'en_US' && (
                <ul className='nav nav-pills' id='pills-tab'>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/profile-en`}>
                      {__('網站帳號', 'cec-plugin-stores')}
                    </a>
                  </li>
                  {info && info.spcode === 'C4' && (
                    <li className='nav-item'>
                      <a
                        className='nav-link'
                        href={`${VC_CONFIG.INDEX_URL}/pwd-en`}>
                        {__('更改密碼', 'cec-plugin-stores')}
                      </a>
                    </li>
                  )}
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/loyaltyprofile-en`}>
                      {__('好康卡會員資料', 'cec-plugin-stores')}
                    </a>
                  </li>
                  {/* <li className="nav-item"><a className="nav-link" href={`${VC_CONFIG.INDEX_URL}/payment-en`} >{__('我的消費紀錄','cec-plugin-stores')}</a></li> */}
                  <li className='nav-item current_page_item highlight'>
                    <a className='nav-link'>
                      {__('點數紀錄', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/invoice-en`}>
                      {__('電子發票記錄', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/connect-en`}>
                      {__('第三方登入設定', 'cec-plugin-stores')}
                    </a>
                  </li>
                </ul>
              )}
            </div>
            <div className='container'>
              <div className='row no-gutters mx-n3 mb-4'>
                <div className='col-lg-3 px-3'>
                  <div className='card border-0 shadow-0 h-100'>
                    <div className='card-body p-5'>
                      <div className='row justify-content-center'>
                        <div className='col-6 col-lg-9'>
                          <h5 className='h4 text-navy text-center mb-0'>
                            {__('查詢月份', 'cec-plugin-stores')}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-lg-9 px-3'>
                  <div className='card border-0 shadow-0 h-100'>
                    <div className='card-body p-5'>
                      <div className='row'>
                        <div className='col-sm-4'>
                          <select
                            className='form-select selectpicker'
                            name='SelectMonth'
                            id='SelectMonth'
                            value={this.state.selectmonth}
                            onChange={(e) => {
                              query.start_dt = e.target.value
                              query.end_dt = moment(e.target.value)
                                .endOf('month')
                                .format('YYYY-MM-DD')
                              this.loadData(query)
                              this.setState({ selectmonth: e.target.value })
                              console.log('1111', this.state.selectmonth)
                            }}
                          />
                        </div>
                        <div className='col-sm-8'>
                          <p className='h6 text-navy fw-700 mb-2'>
                            {__(
                              '網站僅提供六個月內點數記錄查詢, 若您對您的點數記錄有任何疑問，可以撥打客服專線：0809-001-365 查詢！',
                              'cec-plugin-stores',
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='row no-gutters mx-n3 mb-4'>
                <div className='col-12 px-3'>
                  <div className='card border-0 shadow-0 h-100'>
                    <div className='card-body p-5 p-lg-0'>
                      <div className='flex-table' data-theme='success'>
                        <div className='thead'>
                          <ul className='table-row'>
                            <li>{__('消費日期', 'cec-plugin-stores')}</li>
                            <li>{__('消費地點', 'cec-plugin-stores')}</li>
                            <li>{__('交易型態', 'cec-plugin-stores')}</li>
                            <li>{__('消費金額', 'cec-plugin-stores')}</li>
                            <li>{__('紅利點數', 'cec-plugin-stores')}</li>
                            <li>{__('點數折抵', 'cec-plugin-stores')}</li>
                          </ul>
                        </div>
                        <div className='tbody'>
                          {tableData.length == 0 && (
                            <ul className='table-row'>
                              <li data-title='消費日期'>
                                {__(
                                  '尚無任何點數記錄',
                                  'cec-plugin-stores',
                                )}
                              </li>
                            </ul>
                          )}
                          {tableData.map((v) => {
                            return (
                              <ul className='table-row'>
                                <li data-title='消費日期'>
                                  {v.awd_dt && v.awd_dt}
                                </li>
                                <li data-title='消費地點'>
                                  {v.store_name && v.store_name}
                                  {!v.store_name &&
                                    __('店外消費', 'cec-plugin-stores')}
                                </li>
                                <li data-title='交易型態'>
                                  {v.trans_type &&
                                    this.TransType(v.trans_type)}
                                </li>
                                <li data-title='消費金額'>
                                  {Local == 'en_US' &&
                                    v.trans_amt &&
                                    `$${v.trans_amt}`}
                                  {Local == 'zh_TW' &&
                                    v.trans_amt &&
                                    `${v.trans_amt}元`}
                                </li>
                                <li data-title='紅利點數'>
                                  {v.earned_points && v.earned_points}
                                  {__('點', 'cec-plugin-stores')}
                                </li>
                                <li data-title='點數折抵'>
                                  {v.burned_points && v.burned_points}
                                  {__('點', 'cec-plugin-stores')}
                                </li>
                              </ul>
                            )
                          })}
                        </div>
                      </div>
                      {/* <div className="text-center mt-5 my-lg-5"><a className="h6 btn btn-success rounded-pill px-5 py-2 mb-0" role="button" href="#">看更多</a></div> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className='row no-gutters mx-n3 mb-4'>
                <div className='col-lg-3 px-3'>
                  <div className='card border-0 shadow-0 h-100'>
                    <div className='card-body d-flex justify-content-center align-items-center pb-0 pt-5 p-lg-5'>
                      <h5 className='h4 text-navy text-center'>
                        {__('注意事項', 'cec-plugin-stores')}
                      </h5>
                    </div>
                  </div>
                </div>
                <div className='col-lg-9 px-3'>
                  <div className='card border-0 shadow-0 h-100'>
                    <div className='card-body p-5'>
                      <p className='h6 text-navy text-justify'>
                        {__(
                          '如您發現姓名或生日與您申請資料不符，請與客服中心聯絡作資料的修改，以確保會員資料的正確性。',
                          'cec-plugin-stores',
                        )}
                      </p>
                      <p className='h6 text-navy text-justify'>
                        {__(
                          '客服中心：市話 0809-001-365 / 手機(02)8006-9999 ',
                          'cec-plugin-stores',
                        )}
                      </p>
                      <p className='h6 text-navy text-justify'>
                        {__(
                          '※ 由於促銷目錄為提前印製，故於網站更新個人地址後，目錄寄件資料更新約需30個工作天，造成您不便之處盼您見諒！！',
                          'cec-plugin-stores',
                        )}
                      </p>
                      <p className='h6 text-navy text-justify'>
                        {__(
                          '※ 如需取消促銷目錄寄送的服務，請與客服中心聯絡，將有專人為您提供服務。',
                          'cec-plugin-stores',
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
    )
  }
}

// 編輯器
const listGrid = { gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 4 }
export class UserPointEditor extends Component {
  formRef = React.createRef()
  state = {
    listInfo: _.cloneDeep(defaultListInfo),
  }
  componentDidMount() {
    AppHelper.updateConfig()
    console.log('kkk', this.props.attributes)

    this.formRef.current.setFieldsValue(this.props.attributes)
  }
  render() {
    const listInfo = this.state.listInfo
    const options = _.get(this, 'props.app.options', {})
    console.log('editor', this.props)

    return (
      <div className='wp-block-cec-vulcan-block-catalogue-list-editor'>
        <h2>會員點數紀錄模組</h2>
        <Form ref={this.formRef} name='basic' className='basicForm' />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/blocks/users/user-point.js